import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChildren } from '@angular/core';
import { ActionPlanPanelConfigurations } from './action-plan-panel-configurations';
import { KlaHttpService } from '../services/kla.http.service';
import { Image } from '../services/kla.data.models';
import { ActivatedRoute } from '@angular/router';
import { StripSpecialCharsPipe } from '../strip-special-chars/strip-special-chars.pipe';
import { ActionTaxonomyGoalComponent } from '../action-plan-subpanel/action-taxonomy-goal.component';
import { v4 as uuid } from 'uuid';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { Subscription } from 'rxjs';


@Component({
  selector: 'kla-action-taxonomy-category',
  templateUrl: './action-taxonomy-category.component.html',
  styleUrls: ['./action-taxonomy-category.component.scss'],
  standalone: true,
  imports: [ CommonModule, ActionTaxonomyGoalComponent, MatExpansionModule, StripSpecialCharsPipe ]
})
export class ActionTaxonomyCategoryComponent implements OnInit, OnDestroy, AfterViewInit {

  panelOpenState = false;
  image: string;
  color: string;
  panel: ActionPlanPanelConfigurations;
  panelId = uuid();

  @Input() config: string;
  @Input() collapseChildren = false;
  @Input() categories: any[];
  @Input() columnNames: any;
  @Input() columnsActive: any;

  @ViewChildren(ActionTaxonomyGoalComponent) subPanels: ActionTaxonomyGoalComponent[];

  private _subscriptions: Subscription[] = [];

  constructor(
    private httpService: KlaHttpService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.panel = JSON.parse(this.config);
    const imageConfig: Image = {
      id: String(this.panel.imageId),
      width: 320,
      height: undefined,
      crop_config: this.panel.cropConfig
    };
    this.image = this.httpService.getCroppedImagePath(imageConfig);

    this.color = this.panel.color;
  }

  ngAfterViewInit(): void {
    if (this.route.snapshot.queryParams.category && StripSpecialCharsPipe.strip(this.panel.title) === this.route.snapshot.queryParams.category) {
      this.panelOpenState = true;
      this.scroll();
    }
    this._subscriptions.push(
      this.route.queryParams.subscribe(params => {
        if (params.category && StripSpecialCharsPipe.strip(this.panel.title) === params.category) {
          this.panelOpenState = true;
          this.scroll();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  scroll() {
    const el = document.getElementById(`${StripSpecialCharsPipe.strip(this.panel.title)}-category`);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({
          block: 'center'
        });
      }, 400);
    }
  }

  handleOpened() {
    this.panelOpenState = true;
    if (this.subPanels) {
      this.subPanels.forEach(subPanel => {
        subPanel.handleParentOpened();
      });
    }
    this.applyStyles();
    //Scroll into panel functionality
    setTimeout(() => {
      const options = {
        behavior: "smooth" as ScrollBehavior,
        block: "start" as ScrollLogicalPosition,
        inline: "center" as ScrollLogicalPosition
      };
       let panel = document.getElementById(this.panelId);
       panel.scrollIntoView(options);
     }, 500)
  }

  handleClosed() {
    this.panelOpenState = false;
    this.subPanels.forEach(subPanel => {
      subPanel.handleParentClosed();
    });
  }

  applyStyles() {
    const existingStyle = document.getElementById('panel-mat-tooltip');
    if (typeof (existingStyle) != 'undefined' && existingStyle != null) {
      existingStyle.remove();
    }
    const style = document.createElement('style');
    const isiOS = this.isTabletPortrait() && this.isiOS();
    const cloudImgPath = (isiOS) ? '/assets/action-plan-icons/flipped-rotated-cloud-dialog.png' : '/assets/action-plan-icons/cloud-dialog.png';
    const bgPosition = (isiOS) ? 'top' : 'bottom';
    style.id = 'panel-mat-tooltip';
    style.innerHTML = `.mat-tooltip {
      background: transparent url(${cloudImgPath}) 0% 0% no-repeat padding-box !important;
      font-size: 11px !important;
      font-weight: bold !important;
      background-size: contain !important;
      background-position: ${bgPosition} !important;
      color: ${this.color} !important;
      padding: 20px 30px !important;
    }
    .mat-tooltip-panel {
       -webkit-transform: translate(-20px, 25px) !important;
        transform: translate(-20px, 25px) !important;
    }
    .cdk-overlay-pane {
      position: fixed !important;
    }
    `;
    document.getElementsByTagName('head')[0].appendChild(style);
  }

  isTabletPortrait() {
    return window.innerWidth < 1023;
  }

  isiOS() {
    const iDevices = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ];

    if (!!navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          return true;
        }
      }
    }

    return false;
  }

}
